/**
 * `Promise.withResolvers` fallback for Chrome/Edge < 119, Firefox < 121,
 * Safari < 17.4.
 *
 * pdf.js 4.x calls this at runtime. A large share of production traffic runs
 * Chrome/Edge 109 — the terminal version on Windows 8.1 — where the call throws
 * and the PDF preview never resolves. Vite lowers syntax, not runtime APIs, so
 * the fallback has to be shipped explicitly.
 *
 * Installed only when the native method is absent; modern engines keep theirs.
 * Worker scopes have a separate global — see public/pdf-worker/pdf.worker.shim.mjs.
 */
// Side-effect-only module; this marker makes it an ES module so it can be
// `import`ed (pdfWorkerSetup and the test both import it) rather than being
// treated as a global script.
export {};

if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
}
